import { createFileRoute, redirect } from "@tanstack/react-router";

// Permanent: this path is posted on Indeed and printed on flyers, and board scoping now lives in
// `?board=`.
export const Route = createFileRoute("/careers/$slug/board/$boardSlug")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/careers/$slug",
      params: { slug: params.slug },
      search: { board: params.boardSlug },
      replace: true,
    });
  },
});
